<template>
  <transition name="zm-zoom-in-top" @after-leave="doDestroy">
    <div
      v-show="showPopper"
      class="zm-autocomplete-suggestion zm-popper"
      :class="{ 'is-loading': !parent.hideLoading && parent.loading }"
      :style="{ width: dropdownWidth }"
      role="region">
      <zm-scrollbar
        wrap-class="zm-autocomplete-suggestion__wrap"
        ref="scrollbar">
        <ul role="listbox"
            tabindex="-1"
            :aria-label="listLabel"
            :aria-labelledby="listLabelBy"
            :id="id+'-autocomplete-list'"
            class="zm-autocomplete-suggestion__list">
          <li v-if="!parent.hideLoading && parent.loading"><i class="zm-icon-loading"></i></li>
          <slot v-else></slot>
        </ul>
      </zm-scrollbar>
    </div>
  </transition>
</template>
<script>
  import Popper from '../../utils/vue-popper';
  import Emitter from '../../mixins/emitter';
  import ZmScrollbar from '../scrollbar';

  export default {
    components: { ZmScrollbar },
    mixins: [Popper, Emitter],

    componentName: 'ZmAutocompleteSuggestions',

    data() {
      return {
        parent: this.$parent,
        dropdownWidth: ''
      };
    },

    props: {
      visibleArrow: false,
      options: {
        default() {
          return {
            gpuAcceleration: false
          };
        }
      },
      id: String,
      listLabel: String,
      listLabelBy: String
    },

    methods: {
      select(item) {
        this.dispatch('ZmAutocomplete', 'item-click', item);
      }
    },

    updated() {
      this.$nextTick(_ => {
        this.popperJS && this.updatePopper();
      });
    },

    mounted() {
      this.$parent.popperElm = this.popperElm = this.$el;
      this.referenceElm = this.$parent.$refs.input.$refs.input;
      this.referenceList = this.$el.querySelector('.zm-autocomplete-suggestion__list');
      this.referenceList.setAttribute('role', 'listbox');
      this.referenceList.setAttribute('id', this.id);
    },

    created() {
      this.$on('visible', (val, inputWidth) => {
        this.dropdownWidth = inputWidth + 'px';
        this.showPopper = val;
      });
    }
  };
</script>

<style lang="scss">
  @import "../../scss/mixins/mixins";
  @import "../../scss/mixins/utils";
  @import "../../scss/common/var";
  @import "../../scss/common/popper";

  @include b(autocomplete-suggestion) {
    margin: 5px 0;
    box-shadow: $--box-shadow-light;
    border-radius: $--border-radius-base;
    overflow: hidden;
    background-color: $--color-white;

    @include e(wrap) {
      max-height: 240px;
      padding: 0;
      box-sizing: border-box;
    }

    @include e(list) {
      margin: 0;
      padding: 0;
      &:focus{
        outline: none;
      }
    }

    & li {
      padding: 4px 12px;
      margin: 0;
      line-height: 24px;
      cursor: pointer;
      color: $--select-option-color;
      font-size: $--font-size-base;
      list-style: none;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &:hover {
        background-color: $--select-option-hover-background;
        color: $--select-option-selected;
      }
      &:active {
        background-color: $--background-color-pressed;
        color: $--select-option-selected;
      }

      &.highlighted {
        background-color: $--select-option-hover-background;
        color: $--select-option-selected;
      }

      &.divider {
        margin-top: 6px;
        border-top: 1px solid $--color-black;
      }

      &.divider:last-child {
        margin-bottom: -6px;
      }
    }

    @include when(loading) {
      li {
        text-align: center;
        height: 100px;
        line-height: 100px;
        font-size: 20px;
        color: #999;
        @include utils-vertical-center;

        &:hover {
          background-color: $--color-white;
        }
      }

      & .zm-icon-loading {
        vertical-align: middle;
      }
    }
  }
</style>
